import { put, select, takeEvery } from 'redux-saga/effects';
import { Campaign } from 'entities/campaign';
import { Selectors as Router } from 'router';
import { Selectors as CampaignSelectors } from 'sections/campaigns/state/campaigns';
import { Service } from 'sections/campaigns/state/services';
import { CompleteWithEntity, ISelectors, IUpdateActions, Types } from 'services/genericAPIGatewayService';
import { Action } from 'store';
import { Site } from '../../entities/site';
import { Actions as SiteActions, Selectors as SiteSelectors } from '../sites';

function* appendCampaignToPriorityList(
  clientActions: IUpdateActions<Site>,
  clientSelectors: ISelectors<Site>,
  campaignSelectors: ISelectors<Campaign>,
  campaignId: string,
) {
  const siteId: string = yield select(Router.getSiteId);
  if (!siteId) {
    return;
  }

  const client: Site = yield select(clientSelectors.getEntity, siteId);
  const campaignIds: string[] = yield select(campaignSelectors.getEntityIds);
  // Don't overwrite the priorities if we haven't loaded them properly
  if (!client || !client.campaignPriorities || (client.campaignPriorities.length === 0 && campaignIds.length > 1)) {
    return;
  }

  const updatedClient: Site = {
    ...client,
    campaignPriorities: [...client.campaignPriorities, campaignId],
  };

  yield put(clientActions.requestUpdate(siteId, updatedClient));
}

const isCampaignCreationAction = (action: Action): boolean =>
  action.type === Types.CREATE_COMPLETED && action.service === Service.Campaigns;

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function* prioritiseNewCampaign() {
  yield takeEvery(isCampaignCreationAction, (action: CompleteWithEntity<Campaign, Service.Campaigns>) =>
    appendCampaignToPriorityList(SiteActions, SiteSelectors, CampaignSelectors, action.payload.id),
  );
}
